import React from "react";

import { NavLink } from "react-router";

import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";

import { FormattedMessage } from "@mnemonic/intl";
import Link from "@mnemonic/mui/Link";

import type { IEnrollUsernamePassword } from "./useVerifyUsernamePassword";

export const EnrollmentStepper = ({ steps, activeStep }: IEnrollUsernamePassword) => {
  if (activeStep === -1) return null;
  return (
    <>
      <Typography variant="h5">
        <FormattedMessage id="login.verify.title" defaultMessage="Verify user and set password" />
      </Typography>

      {/* Hide the "Already verified? Log in" when enrolling users have authenticated */}
      {activeStep != steps.length - 1 && (
        <Link component={NavLink} to={{ pathname: `/login` }}>
          <FormattedMessage id="login.verify.verified.already" defaultMessage="Already verified? Log in" />
        </Link>
      )}

      <Stepper activeStep={activeStep} alternativeLabel sx={(theme) => ({ my: theme.spacing(5) })}>
        {steps.map((step) => (
          <Step key={step.key}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </>
  );
};
